import React from "react";

function AboutVizzhyVideo({ isOpen, closeModal }) {
  const handleClose = () => {
    closeModal(); 
  };

  if (!isOpen) return null;

 const aboutVideosection='https://vizzhy-website-new.s3.us-east-1.amazonaws.com/vizzhy-website-video.mp4';
 
  return (
    <div className="about-vizzhy-video">
      <div className="w-100 d-flex justify-content-end">
        <span className="material-symbols-outlined cursor-pointer" onClick={handleClose}>
          close
        </span>
      </div>
      <div className="p-4">
        <video
          controls
          autoPlay
          // src="https://vizzhy-website-new.s3.us-east-1.amazonaws.com/vizzhy-website-video.mp4"
          src={aboutVideosection} alt='aboutvideo'
          style={{ width: "100%", height: "auto" }}
        />
      </div>
    </div>
  );
}

export default AboutVizzhyVideo;
